import React, { useEffect, useState } from "react";
import { Guarantees } from "../../../components/Guarantees";
import { formatPrice } from "../../../helpers/index";
import { useSearchParams } from "react-router-dom";
import bgImage from "../../../assets/img/img-09-10-23/bg-decore-top-center.svg";
import { useSelector } from "react-redux";
import { Accordion } from "../../../components/ui/Accordion";
import { isPatCourse } from "../../../helpers/patBooking";

export const OrderDetails = ({ course }) => {
  const selectedCourse = useSelector((state) => state.courses.selectedCourse);
  const isPatBooking = isPatCourse(course?.pcode || selectedCourse?.pcode);

  const learners = useSelector((state) => state.courses.learners);
  const [seconds, setSeconds] = useState(15 * 60);

  const [params] = useSearchParams();
  const step = Number(params.get("step"));

  const checkPlusZero = (value) => {
    return String(value)?.length < 2 ? `0${value}` : value;
  };

  useEffect(() => {
    if (isPatBooking) return;
    const interval = setInterval(() => {
      // Count down, but never below zero -- the banner used to drift into a
      // negative "-27:-5" once a customer spent >15 min in checkout.
      setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [isPatBooking]);

  return (
    <div className="col-lg-6 order-first order-lg-last">
      <div className="order-info">
        <div className="order-info__head">
          {isPatBooking ? (
            <span>Complete your booking to confirm your place</span>
          ) : (
            <>
              <span>Your seat has been reserved for:</span>
              <span>
                {checkPlusZero(Math.max(0, Math.floor(seconds / 60))) +
                  ":" +
                  checkPlusZero(Math.max(0, seconds % 60))}
              </span>
            </>
          )}
        </div>
        <div className="order-info__body ">
          <div className="order-info__body-head">
            <h3 className="mb-16">Your order</h3>
            {learners.length > 0 && (
              <h3 className="mb-16">
                £
                {formatPrice(
                  (selectedCourse.accept_deposit === 1
                    ? +selectedCourse.price_deposite.toFixed(2)
                    : +selectedCourse.price_online.toFixed(2)) *
                    (learners.length > 1
                      ? learners.length - 1
                      : learners.length),
                )}
              </h3>
            )}
          </div>
          <div
            className="card card-primary card-dash bg-styles-top-center"
            style={{
              backgroundImage: `url(${bgImage})`,
            }}
          >
            <div className="card-body ">
              {step === 4 ? (
                <Accordion
                  headClasses={"spoller__head--style-2 mb-0"}
                  title={
                    <>
                      <h6 className="fs-18 mb-4px">{course?.center}</h6>
                      {/* (6 Hours) */}
                      <p className="mb-16" style={{ fontWeight: "400" }}>
                        {course?.name}
                      </p>
                      {course?.delivered_by ? (
                        <p className="mb-16 fs-14">
                          Delivered by{" "}
                          <span className="fw-600">{course.delivered_by}</span>
                        </p>
                      ) : null}
                      <p>{`Number of learners - ${
                        learners.length > 1
                          ? learners.length - 1
                          : learners.length
                      }`}</p>
                    </>
                  }
                  type="secondary"
                >
                  <>
                    <p
                      className="fw-600 mb-16 lh-22"
                      style={{ marginTop: "16px" }}
                    >
                      Start date - {course?.formattedStartDate}
                    </p>
                    <div className="mb-16 lh-22">
                      <div
                        className="order-details-description"
                        dangerouslySetInnerHTML={{
                          __html: course?.description,
                        }}
                      ></div>
                    </div>
                  </>
                </Accordion>
              ) : (
                <>
                  <h6 className="fs-18 mb-4px">{course?.center}</h6>
                  {/* (6 Hours)  */}
                  <p className="mb-16">{course?.name}</p>
                  {course?.delivered_by ? (
                    <p className="mb-16 fs-14">
                      Delivered by{" "}
                      <span className="fw-600">{course.delivered_by}</span>
                    </p>
                  ) : null}
                  <p className="fw-600 mb-16 lh-22">
                    Start date - {course?.formattedStartDate}
                  </p>
                  <div className="mb-16 lh-22">
                    <div
                      className="order-details-description"
                      dangerouslySetInnerHTML={{ __html: course?.description }}
                    ></div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-none d-lg-block">
        <Guarantees row={false} hideReviews />
      </div>
    </div>
  );
};
